import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { Box, type SxProps, type Theme } from "@mui/material";
import type { FC } from "react";
import { FONT_SIZE, INK } from "../../../theme/tokens";

type Props = {
	/** The value it had, already formatted. */
	before: string;
	/** The value it was changed to, already formatted. */
	after: string;
	/** Accessible names for the two sides (already translated) — "Before", "After". */
	beforeLabel: string;
	afterLabel: string;
	dataTestId?: string;
	sx?: SxProps<Theme>;
};

/** One value that changed: the old one struck through, an arrow, the new one. Semantic `<del>`/`<ins>`. */
export const ValueChange: FC<Props> = ({ before, after, beforeLabel, afterLabel, dataTestId, sx }) => (
	<Box
		component="span"
		data-testid={dataTestId}
		sx={[{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", columnGap: 0.75, fontSize: FONT_SIZE.CAPTION }, ...(Array.isArray(sx) ? sx : [sx])]}
	>
		<Box component="del" aria-label={`${beforeLabel}: ${before}`} sx={{ color: INK.MUTED, textDecorationColor: INK.MUTED }}>
			{before}
		</Box>
		<ArrowForwardRoundedIcon
			aria-hidden
			sx={{ fontSize: FONT_SIZE.CAPTION, color: INK.MUTED, transform: (theme) => (theme.direction === "rtl" ? "rotate(180deg)" : "none") }}
		/>
		<Box component="ins" aria-label={`${afterLabel}: ${after}`} sx={{ textDecoration: "none", color: INK.PRIMARY, fontWeight: 600 }}>
			{after}
		</Box>
	</Box>
);
